import Vue from 'vue'

const state = () => ({
  videos: {},
  articles: {},
  jwpData: {},
  availableGames: {
    'all-games': { key: 'all-games', name: 'All Games'},
    'leagueoflegends': { key: 'leagueoflegends', name: 'League of Legends' },
    'fortnite': { key: 'fortnite', name: 'Fortnite' },
    'super-smash-bros-ultimate': { key: 'super-smash-bros-ultimate', name: 'Super Smash Bros. Ultimate' },
    'teamfight-tactics': { key: 'teamfight-tactics', name: 'Teamfight Tactics' },
    'csgo': { key: 'csgo', name: 'CS:GO' },
    'overwatch': { key: 'overwatch', name: 'Overwatch' },
    'magic-the-gathering': { key: 'magic-the-gathering', name: 'Magic: The Gathering Arena' },
  }
})

const mutations = {
  'ADD_JWP_DATA': (state, payload) => {
    Vue.set(state.jwpData, payload.key, payload.value)
  },
  'SET_VIDEOS': (state, payload) => {
    Vue.set(state, 'videos', payload)
  },
  'ADD_VIDEOS': (state, payload) => {
    for (let i = 0; i < Object.keys(payload).length; i++) {
      let key = Object.keys(payload)[i]
      Vue.set(state.videos, key, payload[key])
    }
  },
  'SET_ARTICLES': (state, payload) => {
    Vue.set(state, 'articles', payload)
  },
  'ADD_ARTICLES': (state, payload) => {
    for (let i = 0; i < Object.keys(payload).length; i++) {
      let key = Object.keys(payload)[i]
      Vue.set(state.articles, key, payload[key])
    }
  }
}

const actions = {
  addJWPData ({commit}, payload) {
    commit('ADD_JWP_DATA', payload)
  },
  setVideos ({commit}, payload) {
    commit('SET_VIDEOS', payload)
  },
  addVideos ({commit}, payload) {
    commit('ADD_VIDEOS', payload)
  },
  setArticles ({commit}, payload) {
    commit('SET_ARTICLES', payload)
  },
  addArticles ({commit}, payload) {
    commit('ADD_ARTICLES', payload)
  }
}

const getters = {
  getVideos: state => { return state.videos },
  getArticles: state => { return state.articles },
  getJWPData: state => { return state.jwpData },
  getAvailableGames: state => { return state.availableGames }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/video_of_the_day.js